document.addEventListener("DOMContentLoaded", () => {
  const wrapper  = document.querySelector(".subcategory-viewer-fullscreen");
  const scroller = document.querySelector(".subcategory-viewer-fullscreen .subcategory-list");
  const prevBtn  = document.querySelector(".subcategory-viewer-fullscreen .nav-button--prev");
  const nextBtn  = document.querySelector(".subcategory-viewer-fullscreen .nav-button--next");
  const stepPct  = 0.8;

  // Aggiungi questo controllo all'inizio
  if (!scroller) {
    console.warn("Elemento .subcategory-list non trovato");
    return; // Esci dalla funzione se l'elemento non esiste
  }

  function maxScrollX(){
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  function updateUI(){
    if(!scroller) return;
    const ul = scroller.querySelector("ul");
    const maxX = scroller.scrollWidth - scroller.clientWidth;
    const x = scroller.scrollLeft;

    if (maxX <= 1){
        ul.style.justifyContent = "center !important";
        prevBtn?.classList.add("is-hidden");
        nextBtn?.classList.add("is-hidden");
        wrapper?.classList.remove("has-left-shadow","has-right-shadow");
        return;
    } else {
        ul.style.justifyContent = "flex-start !important";
    }

    if (x <= 1){
      prevBtn?.classList.add("is-hidden");
      wrapper?.classList.remove("has-left-shadow");
    } else {
      prevBtn?.classList.remove("is-hidden");
      wrapper?.classList.add("has-left-shadow");
    }

    if (x >= maxX - 1){
      nextBtn?.classList.add("is-hidden");
      wrapper?.classList.remove("has-right-shadow");
    } else {
      nextBtn?.classList.remove("is-hidden");
      wrapper?.classList.add("has-right-shadow");
    }
  }

  function scrollStep(dir){
    const step = Math.max(160, Math.floor(scroller.clientWidth * stepPct));
    scroller.scrollBy({ left: dir * step, behavior: "smooth" });
  }

  prevBtn?.addEventListener("click", () => scrollStep(-1));
  nextBtn?.addEventListener("click", () => scrollStep(+1));

  scroller?.addEventListener("scroll", updateUI);
  window.addEventListener("resize", updateUI);

  // Ora il ResizeObserver è sicuro
  const ro = new ResizeObserver(updateUI);
  ro.observe(scroller); // scroller è garantito esistere qui
  
  scroller.querySelectorAll("img").forEach(img => img.addEventListener("load", updateUI, { once:true }));

  updateUI();
});
